// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "accountants-spa." + "e1fbfb3765e0ffa2d86e" + ".chunk.css";
};